export const classUser = (playerClass) => {
  switch (playerClass) {
    case 16:
      return "DarkKnight";
    case 17:
      return "BladeKnight";
    case 18:
      return "BladeMaster";
    case 0:
      return "DarkWizard";
    case 1:
      return "SoulMaster";
    case 2:
      return "GrandMaster";
    case 64:
      return "DarkLord";
    case 66:
      return "LordEmperor";
    case 48:
      return "MagicGladiator";
    case 50:
      return "DuelMaster";
    case 32:
      return "FairyElf";
    case 33:
      return "MuseElf";
    case 34:
      return "HighElf";
    case 80:
      return "Summoner";
    case 81:
      return "BloodySummoner";
    case 82:
      return "DimensionMaster";
    case 96:
      return "RageFighter";
    case 97:
    case 98:
      return "FistMaster";
    default:
      return "gray";
  }
};
